import { DataBean } from "../DataBean";

export class SIIFTCON6Value extends DataBean {


    public async getSIIFTCON6ValueByAccountantID(accountantID:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSIIFTCON6ValueByAccountantID_String", [accountantID]);
    }

 
}